import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnChanges,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { InvoiceEmail } from "../../../core/models/orders/invoicedEmail";
import { GetUserDto } from "../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { CommonModule } from "@angular/common";
import { UserManagementService } from "../../../core/services/user-management.service";
import { FormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-invoice-review-invoice-emails",
  templateUrl: "./invoice-review-invoice-emails.component.html",
  styleUrls: ["./invoice-review-invoice-emails.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    FormsModule,
    CheckboxModule,
    SelectModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class InvoiceReviewInvoiceEmailsComponent implements OnInit, OnChanges {
  @Input() invoiceEmailListing: InvoiceEmail[] = [];
  @Output() invoiceEmailDeletedEvent = new EventEmitter<InvoiceEmail[]>();
  @Output() invoiceEmailAddEvent = new EventEmitter<boolean>();
  @Output() invoiceEmailCopyBcEmailEvent = new EventEmitter<string>();
  @Output() invoiceEmailCopyBacEmailEvent = new EventEmitter<string>();
  @Output() invoiceEmailAddBcBacEmailEvent = new EventEmitter<string>();
  @Output() invoiceEmailEditEvent = new EventEmitter<InvoiceEmail>();
  @Output() invoiceEmailSaveEvent = new EventEmitter<InvoiceEmail>();

  invoiceEmailSelected = [];
  copyBcCheckbox = false;
  copyBacCheckbox = false;
  showSmallLoader = false;
  userData!: GetUserDto;
  type = [
    {
      id: 1,
      name: "Business",
    },
    {
      id: 2,
      name: "Invoice",
    },
    {
      id: 3,
      name: "Payable",
    },
    {
      id: 4,
      name: "Delivery",
    },
    {
      id: 5,
      name: "Other",
    },
    {
      id: 6,
      name: "Buyer",
    },
  ];

  @ViewChild("dt") table!: Table;

  constructor(
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService
  ) {}
  ngOnInit(): void {
    this.getUserProfile();
  }

  ngOnChanges(): void {
    this.ngOnInit();
  }

  onDelete() {
    this.invoiceEmailDeletedEvent.emit(this.invoiceEmailSelected);
    this.invoiceEmailSelected = [];
  }

  onAdd() {
    this.invoiceEmailAddEvent.emit(true);
    this.invoiceEmailSelected = [];
  }

  onEditRow(invoiceEmails: InvoiceEmail) {
    this.invoiceEmailEditEvent.emit(invoiceEmails);
  }

  onSaveRow(invoiceEmails: InvoiceEmail) {
    this.invoiceEmailSaveEvent.emit(invoiceEmails);
  }

  copyBcBAcToGrid() {
    if (this.copyBacCheckbox) {
      const index = this.invoiceEmailListing.findIndex(
        x => x.email === this.userData?.primaryBACEmail
      );
      if (index == -1) {
        this.invoiceEmailAddBcBacEmailEvent.emit(
          this.userData?.primaryBACEmail
        );
        this.onAdd();
      }
      this.invoiceEmailCopyBacEmailEvent.emit(this.userData?.primaryBACEmail);
    } else {
      this.invoiceEmailCopyBacEmailEvent.emit("");
    }

    if (this.copyBcCheckbox) {
      const index = this.invoiceEmailListing.findIndex(
        x => x.email === this.userData?.sendEmailAs
      );
      if (index == -1) {
        this.invoiceEmailAddBcBacEmailEvent.emit(
          this.userData?.sendEmailAs ?? this.userData?.displayEmailAs
        );
        this.onAdd();
      }
      this.invoiceEmailCopyBcEmailEvent.emit(
        this.userData?.sendEmailAs ?? this.userData?.displayEmailAs
      );
    } else {
      this.invoiceEmailCopyBcEmailEvent.emit("");
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          this.isCopyBcBacEnabled();
        }
      },
    });
  }

  isCopyBcBacEnabled() {
    const indexForBac = this.invoiceEmailListing.findIndex(
      x => x.email === this.userData?.primaryBACEmail
    );
    if (indexForBac != -1) {
      this.copyBacCheckbox = true;
      this.invoiceEmailCopyBacEmailEvent.emit(this.userData?.primaryBACEmail);
    }

    const indexForBc = this.invoiceEmailListing.findIndex(
      x => x.email === this.userData?.sendEmailAs
    );
    if (indexForBc != -1) {
      this.copyBcCheckbox = true;
      this.invoiceEmailCopyBcEmailEvent.emit(
        this.userData?.sendEmailAs ?? this.userData?.displayEmailAs
      );
    }
  }
}
